import { memo } from "react";
import { useRouter } from "next/router";
import Component1 from "./component1";
import { useTranslation } from "next-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const CoverageSection = memo(() => {
  const { t } = useTranslation("home");
  const router = useRouter();
  const lang = router.locale || "en";

  return (
    <div
      className={`w-full self-stretch bg-background-color-primary overflow-hidden flex flex-col items-start justify-start box-border gap-6 md:gap-10  z-[2] text-5xl text-text-primary px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] pb-[40px] md:pb-[40px] lg:pb-[60px] lg:pb-[60px] max-w-[1600px] mx-auto`}
    >
      <h2 className="m-0 self-stretch text-start relative text-inherit leading-[120%] font-[inherit] text-[28px] sm:text-[32px] lg:text-[40px] font-medium">
        {t("home.coverageTitle")}
      </h2>

      <Swiper
        dir={lang === "ar" ? "rtl" : "ltr"}
        modules={[Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        breakpoints={{
          640: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1028: {
            slidesPerView: 4,
          },
        }}
        // autoplay={{ delay: 5000 }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        className="w-full"
      >
        {[0, 1, 2, 3]?.map((index) => (
          <SwiperSlide key={index}>
            <Component1
              key={index}
              carbongrowth="/carbongrowth2.svg"
              title={t(`home.coverage.${index}.title`)}
              content={t(`home.coverage.${index}.content`)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
});

export default CoverageSection;
